// window.addEventListener("load", () => {
//   const quantityInput = document.querySelector("input#quantity");
//   if (quantityInput) {
//     quantityInput.addEventListener("change", (event) => {
//       const newQuantity = parseInt(event.target.value);
//       displayHulkCustomMessage(newQuantity);
//     });
//     displayHulkCustomMessage(parseInt(quantityInput.value));
//   } else {
//     console.warn("HULK CUSTOM - No quantity input");
//   }
// });

// function displayHulkCustomMessage(quantity) {
//   const messageOutputElement = document.querySelector('#dynamicMessage');
//   let messageData = null;

//   // find appropriate message
//   if (window.customHulkMessages) {
//     for (const level of window.customHulkMessages) {
//       if (quantity >= level[0]) {
//         messageData = [level[1], level[2]];
//       } else if (quantity < level[0]) {
//         break;
//       }
//     }
//   }

//   if (messageOutputElement && messageData) {
//     messageOutputElement.innerHTML = `for <strong>${messageData[0]}</strong> per pack <strong>(${messageData[1]}/unit)</strong>`;
//   } else {
//     console.warn("HULK CUSTOM - No message output element or message data");
//   }
// }

window.VariantPriceDisplay = {
    isInitialized: false,
    productData: null,
    formattedPrices: null,
    currentVariant: null,
    optionKey: null,
    observer: null,
    volumeTiers: [],

    elements: {
        quantityInput: null,
        messageOutput: null,
        variantPicker: null,
        sizeSelector: null,
        variantDataScript: null,
        hulkVolumeTable: null
    },

   
    init: function () {
        if (this.isInitialized) return;

        
        this.elements.quantityInput = document.querySelector("input#quantity");
        this.elements.messageOutput = document.querySelector('#dynamicMessage');
        this.elements.variantPicker = document.querySelector('variant-picker');
        this.elements.variantDataScript = this.elements.variantPicker ? this.elements.variantPicker.querySelector('script[type="application/json"]') : null;

      
        if (this.elements.variantPicker && this.elements.variantDataScript) {
            console.log('Variant picker found. Initializing variant-specific logic.');
            this.productData = JSON.parse(this.elements.variantDataScript.textContent);
            this.formattedPrices = this.productData.formatted;
            this.optionKey = this._determineOptionKey();

            const urlParams = new URLSearchParams(window.location.search);
            function isDefaultOptionSelected() {
                const dropdownButtonTextElement = document.querySelector('.input-row .custom-select__btn .text-start');
                return dropdownButtonTextElement && dropdownButtonTextElement.textContent.trim().includes('Choose a');
            }

            if (urlParams.has("variant")) {
                this._showPriceElements();
                this._setInitialPrice();
            } else if (!isDefaultOptionSelected()) {
                this._showPriceElements();
                this._setLoadPrice(); 
            } else {
                 this._hidePriceElements();
            }
        } else {
            console.log('No variant picker found. Running default variant logic.');
            this._showPriceElements();
            this._setLoadPrice();
        }
        
        
        const waitForTableAndInitialize = () => {
            let attempts = 0;
            const maxAttempts = 40; 
            const tableCheckInterval = setInterval(() => {
                this.elements.hulkVolumeTable = document.querySelector('.hulkapps-volume-discount-tiers table');
              
                if (this.elements.hulkVolumeTable) {
                    console.log('Success! Volume table found after ' + (attempts * 250) + 'ms.');
                  
                    clearInterval(tableCheckInterval);

                    this._parseVolumeTiers();
                    this._attachQuantityListener();

                    const initialQuantity = parseInt(this.elements.quantityInput.value) || 1;
                    this._displayHulkCustomMessage(initialQuantity);

                    this.isInitialized = true;
                    console.log("VariantPriceDisplay initialized successfully.");
                
                } else if (attempts >= maxAttempts) {
                    clearInterval(tableCheckInterval);
                    console.error('Timeout: HulkApps volume table was not found on the page after 10 seconds.');
                }
                
                attempts++;
            }, 250);
        };
        
        waitForTableAndInitialize();
    },

    _determineOptionKey: function () {
        const dropdownEl = document.querySelector('.option-selector[data-selector-type="dropdown"]');
        if (!dropdownEl) return null;
        const dropdownOptionName = dropdownEl.dataset.option;
        if (!this.productData || !this.productData.options) return null;
        const optionIndex = this.productData.options.findIndex(option => option === dropdownOptionName);
        if (optionIndex === -1) return null;
        return `option${optionIndex + 1}`;
    },

    updateOnVariantChange: function (variant) {
        if (variant) {
            this._updatePriceForVariant(variant);
            this._showPriceElements();

            setTimeout(() => {
                this.elements.hulkVolumeTable = document.querySelector('.hulkapps-volume-discount-tiers table');
                this._parseVolumeTiers();
                const currentQuantity = parseInt(this.elements.quantityInput.value) || 1;
                this._displayHulkCustomMessage(currentQuantity);
            }, 250);

        } else {
            this._hidePriceElements();
        }
    },

    _updatePriceForVariant: function (variant) {
        if (!variant || !this.formattedPrices[variant.id]) return;
        this.currentVariant = variant;
        const priceInfo = this.formattedPrices[variant.id];
        const roundedPricePerUnit = (Math.round(priceInfo.pricePerUnit * 100) / 100).toFixed(2);
        this.elements.messageOutput.innerHTML = `for <strong>${priceInfo.price}</strong> per pack <strong>(${priceInfo.pricePerUnit}/unit)</strong>`;
        $('.product-form.sticky-content-container .minimum-price-message').html(`<span class="unit-value">${priceInfo.price}</span><span class="per-unit"> per pack</span><span class="unit-text">($${roundedPricePerUnit}/unit)</span>`);
    },

    _setInitialPrice: function () {
        const initialVariantId = new URLSearchParams(window.location.search).get('variant');
        if (initialVariantId) {
            const initialVariant = this.productData.variants.find(v => v.id == initialVariantId);
            if (initialVariant) this._updatePriceForVariant(initialVariant);
        }
    },

    _setLoadPrice: function () {
        const defaultVariantScript =  document.querySelector('#defaultVariant script[type="application/json"]');
        if(defaultVariantScript) {
            this.productData = JSON.parse(defaultVariantScript.textContent);
            this.formattedPrices = this.productData.formatted;
            const initialVariant = this.productData.variants.find(v => v.id);
            if (initialVariant) this._updatePriceForVariant(initialVariant);
        } else if (this.productData) {
            const firstAvailableVariant = this.productData.variants.find(v => v.available);
            if (firstAvailableVariant) this._updatePriceForVariant(firstAvailableVariant);
        }
    },
    
    _parseVolumeTiers: function () {
        this.volumeTiers = [];
        if (!this.elements.hulkVolumeTable) {
            console.error("Parse function was called, but hulkVolumeTable is STILL null. Cannot parse tiers.");
            return;
        }

        const rows = this.elements.hulkVolumeTable.querySelectorAll('tbody tr');
        rows.forEach(row => {
            const cells = row.querySelectorAll('td');
            if (cells.length < 2) return;
            const qtyText = cells[0].innerText.trim();
            const priceElement = cells[1].querySelector('.hulkapps-price');
            if (!priceElement) return;
            const priceText = priceElement.innerText.trim();
            let minQty = 0;
            let maxQty = Infinity;
            if (qtyText.includes('-')) {
                const parts = qtyText.split('-');
                minQty = parseInt(parts[0], 10);
                maxQty = parseInt(parts[1], 10);
            } else if (qtyText.includes('+')) {
                minQty = parseInt(qtyText, 10);
            }
            if (!isNaN(minQty)) {
                this.volumeTiers.push({ min: minQty, max: maxQty, message: priceText });
            }
        });
        console.log("SUCCESS: Parsed Volume Tiers:", this.volumeTiers);
    },

    _attachQuantityListener: function () {
        if (!this.elements.quantityInput) return;
        this.elements.quantityInput.addEventListener('input', (event) => {
            const quantity = parseInt(event.target.value, 10);
            if (isNaN(quantity) || quantity < 1) return;
            this._displayHulkCustomMessage(quantity);
        });
    },

    _displayHulkCustomMessage: function (quantity) {
        if (!this.elements.messageOutput) return;

        if (this.volumeTiers.length > 0) {
            const applicableTier = this.volumeTiers.find(tier => quantity >= tier.min && quantity <= tier.max);
            if (applicableTier) {
                this.elements.messageOutput.innerHTML = `for ${applicableTier.message}`;
            } else {
                if (this.currentVariant) this._updatePriceForVariant(this.currentVariant);
            }
        } else {
            if (this.currentVariant) this._updatePriceForVariant(this.currentVariant);
        }
    },

    _hidePriceElements: function () {
        document.querySelector('#dynamicMessage')?.classList.add('btnTBhide');
        setTimeout(function () { document.querySelector('.hulkapps-volumes')?.classList.add('btnTBhide'); }, 1000);
    },

    _showPriceElements: function () {
        document.querySelector('#dynamicMessage')?.classList.remove('btnTBhide');
        document.querySelector('.hulkapps-volumes')?.classList.remove('btnTBhide');
        document.querySelector('.product-form .minimum-price-message')?.classList.remove('btnTBhide2');
    },

    _attachObserver: function () { }
};

document.addEventListener('DOMContentLoaded', function () {
    if (window.VariantPriceDisplay) {
        window.VariantPriceDisplay.init();
    }
});

document.addEventListener('variant:change', function (event) {
    if (window.VariantPriceDisplay && window.VariantPriceDisplay.isInitialized) {
        const variant = event.detail.variant;
        window.VariantPriceDisplay.updateOnVariantChange(variant);
    }
});
